'use client';

import { Breadcrumbs } from '@/components/common/Breadcrumbs/Breadcrumbs';
import { JobDetailFragment, JobOfferFragment } from './gen/graphql/JobRoute.generated';
import { useTranslations } from 'next-intl';
import { JobDescription } from './components/JobDescription';
import { useI18nLabel } from '@/hooks/useI18nLabel';
import { PrefectureValue } from '@/constants/prefectures';
import { JobOffers } from './components/JobOffers';
import { JobSummary } from './components/JobSummary';
import { JobPhotos } from './components/JobPhotos';
import { LogScreenDisplay } from '@/libs/clientEvents/LogScreenDisplay';

export type Props = {
  job: JobDetailFragment;
  offers: JobOfferFragment[];
};

export function JobRoute({ job, offers }: Props) {
  const t = useTranslations();
  const translate = useI18nLabel();

  return (
    <>
      <LogScreenDisplay location="worker_web_job" eventParams={{ jobId: job.id }} />
      <div className="flex flex-col container p-6 pb-10">
        <Breadcrumbs
          breadcrumbs={[
            { label: t('top.title'), href: '/' },
            {
              label: t(`common.prefecture.label.${job.address.prefCode as PrefectureValue}`),
              href: `/jobs?prefecture=${job.address.prefCode}`,
            },
            {
              label: translate(job.crewCategory),
              href: `/jobs?prefecture=${job.address.prefCode}&job_category=${job.crewCategory.id}`,
            },
            { label: job.title },
          ]}
          className="mb-4"
        />
        <JobSummary jobSummary={job} />
        <JobOffers offers={offers} />
        <JobDescription jobDescription={job} />
        <JobPhotos jobPhotos={job} />
      </div>
    </>
  );
}
